module.exports = __webpack_public_path__ + "static/media/parallelogramh_angle0.e581a93b.svg";